import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { addComplianceFeeDataAPI, addDeliveryFeeDataAPI, addPromoDataAPI, deletePromoAPI, editPromoDataAPI, fetchComplianceDataAPI, fetchDeliveryDataAPI, getPromotionListAPI, syncOrderAdminAPI } from '../../redux/apis/metrc';

const initialState = {
  metrc: [],
  loading: false,
  error: null,
  syncOrder: false,
  flavors: [],
};

export const getPromotionList = createAsyncThunk(
  'metrc/getPromotionList',
  async (filters, { rejectWithValue }) => {
    try {
      const res = await getPromotionListAPI(filters);
      return res;
    } catch (error) {

      return rejectWithValue(error.response?.data);
    }
  }
);


export const addPromoData = createAsyncThunk(
  'metrc/addPromoData',
  async ({ data, type }, { rejectWithValue }) => {
    try {
      const res = await addPromoDataAPI(data, type);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const editPromoData = createAsyncThunk(
  'metrc/editPromoData',
  async ({ data, id, type }, { rejectWithValue }) => {
    try {
      const res = await editPromoDataAPI(data, id, type);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);
export const deletePromo = createAsyncThunk(
  'metrc/deletePromo',
  async ({ data, type }, { rejectWithValue }) => {
    try {
      const res = await deletePromoAPI(data, type);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const fetchComplianceData = createAsyncThunk(
  'metrc/fetchComplianceData',
  async (data, { rejectWithValue }) => {
    try {
      const res = await fetchComplianceDataAPI(data);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const addComplianceFeeData = createAsyncThunk(
  'metrc/addComplianceFeeData',
  async ({data}, { rejectWithValue }) => {
    try {
      const res = await addComplianceFeeDataAPI(data);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const syncOrderAdmin = createAsyncThunk(
  'metrc/syncOrderAdmin',
  async (filters, { rejectWithValue }) => {
    try {
      const res = await syncOrderAdminAPI(filters);
      return res;
    } catch (error) {

      return rejectWithValue(error.response?.data);
    }
  }
);

export const fetchDeliveryData = createAsyncThunk(
  'metrc/fetchDeliveryData',
  async (data, { rejectWithValue }) => {
    try {
      const res = await fetchDeliveryDataAPI(data);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const addDeliveryFeeData = createAsyncThunk(
  'metrc/addDeliveryFeeData',
  async ({data}, { rejectWithValue }) => {
    try {
      const res = await addDeliveryFeeDataAPI(data);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

const metrcSlice = createSlice({
  name: 'metrc',
  initialState,
  reducers: {

  },
  extraReducers: (builder) => {
    builder
      .addCase(getPromotionList.pending, (state) => {
        state.loadingList = true;
        state.error = null;
      })
      .addCase(getPromotionList.fulfilled, (state, action) => {

        state.loadingList = false;
        state.promotionList = action.payload;
      })
      .addCase(getPromotionList.rejected, (state, action) => {
        state.loadingList = false;
        state.error = action.payload;
      })


      .addCase(addPromoData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addPromoData.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(addPromoData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(editPromoData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editPromoData.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(editPromoData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deletePromo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deletePromo.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deletePromo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(addComplianceFeeData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addComplianceFeeData.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(addComplianceFeeData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(syncOrderAdmin.pending, (state) => {
        state.syncOrder = true;
        state.error = null;
      })
      .addCase(syncOrderAdmin.fulfilled, (state, action) => {
        state.syncOrder = false;
      })
      .addCase(syncOrderAdmin.rejected, (state, action) => {
        state.syncOrder = false; 
      })

        .addCase(addDeliveryFeeData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addDeliveryFeeData.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(addDeliveryFeeData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});


export const { } = metrcSlice.actions;

export default metrcSlice.reducer;
